export default "__VITE_ASSET__BPxsjyym__"